var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { CommandRequest } from "./models";
import { json, logger } from ".";
function configure(botAuthorization) {
    return new AuthorizedCommands(botAuthorization);
}
const route = {
    messaging: "https://msging.net/commands",
};
const method = {
    GET: "get",
    SET: "set",
    DELETE: "delete",
};
const to = {
    ANALYTICS: "postmaster@analytics.msging.net",
    MESSAGING: "postmaster@msging.net",
    MESSAGING_WA: "postmaster@wa.gw.msging.net",
    MEDIA: "postmaster@media.msging.net",
    ACTIVE_CAMPAIGN: "postmaster@activecampaign.msging.net",
    BUILDER: "postmaster@builder.msging.net",
};
const type = {
    EVENT_TRACK: "application/vnd.iris.eventTrack+json",
    APPLICATION_JSON: "application/json",
    ACTIVE_CAMPAIGN: "application/vnd.iris.activecampaign.campaign+json",
};
export class AuthorizedCommands {
    constructor(botAuthorization) {
        this._botAuthorization = botAuthorization;
        this._client = axios.create({
            headers: {
                "Content-Type": "application/json",
                Authorization: this._botAuthorization,
            },
        });
    }
    getUrlAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const request = new CommandRequest("/upload-media-uri", blip.method.GET, blip.to.MEDIA);
            const client = blip.configure(this._botAuthorization);
            return yield client
                .sendCommandAsync(blip.route.messaging, request)
                .then((resp) => {
                logger.info(`Success on get media url`);
                logger.debug(`Response body: \n ${json.format(resp)}`);
                return resp.resource;
            })
                .catch((err) => {
                logger.error(`Error on get media url: ${err}`);
                throw new Error("Error on get media url");
            });
        });
    }
    uploadBlobAsync(blob, url) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield axios
                .post(url, blob, {
                headers: {
                    "Content-Type": blob.type,
                    Authorization: this._botAuthorization,
                },
            })
                .then((resp) => {
                logger.info(`Success on upload file: \n ${json.format(resp)}`);
                logger.debug(`Response body: \n ${json.format(resp)}`);
                return resp.mediaUri;
            })
                .catch((err) => {
                logger.error(`Error on get media url: ${err}`);
                return "";
            });
        });
    }
    uploadFileAsync(blob) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.getUrlAsync().then((resp) => __awaiter(this, void 0, void 0, function* () {
                return yield this.uploadBlobAsync(blob, resp).then((resp) => {
                    return resp;
                });
            }));
        });
    }
    trackAsync(eventName, value, contactIdentity) {
        return __awaiter(this, void 0, void 0, function* () {
            const client = blip.configure(this._botAuthorization);
            const request = new CommandRequest("/event-track", method.SET, to.ANALYTICS, type.EVENT_TRACK);
            request.setResource({
                category: eventName,
                action: value,
                contact: {
                    identity: contactIdentity,
                },
            });
            yield client
                .sendCommandAsync(blip.route.messaging, request)
                .then((resp) => {
                logger.info(`Success on register bot tracking [${eventName}]`);
                logger.debug(json.format(resp));
            })
                .catch((err) => logger.error(`Error on register bot tracking [${eventName}] : [${err}]`));
        });
    }
    sendCommandAsync(route, request) {
        return __awaiter(this, void 0, void 0, function* () {
            logger.debug(`Sending command to blip`);
            logger.debug(`Request body: \n ${json.format(request)}`);
            return yield this._client
                .post(route, request)
                .then((resp) => {
                if (resp.data.status === "failure") {
                    logger.error(`Error on send command: \n ${json.format(resp.data)}`);
                    throw new Error("Error on send command");
                }
                logger.debug(`${resp.status} - Command sended with success`);
                return resp.data;
            })
                .catch((err) => {
                logger.error(err);
                return err;
            });
        });
    }
}
export const blip = {
    configure,
    route,
    method,
    to,
    type,
};
